const all = ['legalDocument']
const detail = (type?: string) => [...all, type]

export const legalDocumentKeys = {
  all,
  detail,
}
